module.exports = __webpack_public_path__ + "img/KY.6800896b.svg";